import { styled } from '@mui/material'
import { TableCell as BaseTableCell } from '@chilecompra/react-kit/components'

export const Content = styled('section')`
  font-size: 14px;
  line-height: 18px;
  overflow-x: auto;
  padding: ${props => props.padding || '16px 0 10px'};
  width: 100%;
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 24px 0;
  overflow: visible;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    display: ${props => props.display};
    padding: ${props => props.padding && `${props.padding} !important`};
  }
`
